// extracted by mini-css-extract-plugin
export default {"container":"AddUser_container__J4KpA","close":"AddUser_close__MudB7","primary":"AddUser_primary__JqtnF","img":"AddUser_img__kFOc1","form":"AddUser_form__RNyWI"};